var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2519 5.51699H6.58494C4.29494 5.51699 2.43994 7.35199 2.43994 9.61599V15.384C2.43994 17.648 4.29594 19.484 6.58494 19.484H18.2519C20.5419 19.484 22.3969 17.648 22.3969 15.384V9.61599C22.3969 7.35199 20.5409 5.51599 18.2519 5.51599V5.51699ZM15.4489 12.78L9.99194 15.355C9.95866 15.371 9.92186 15.3784 9.88497 15.3763C9.84809 15.3743 9.81231 15.363 9.78097 15.3434C9.74964 15.3239 9.72376 15.2967 9.70574 15.2645C9.68773 15.2322 9.67816 15.1959 9.67794 15.159V9.84999C9.67861 9.81286 9.68866 9.77651 9.70716 9.74432C9.72567 9.71212 9.75202 9.68513 9.78376 9.66587C9.81551 9.6466 9.85161 9.63568 9.88871 9.63413C9.92581 9.63258 9.9627 9.64044 9.99594 9.65699L15.4539 12.392C15.4903 12.4101 15.5208 12.4381 15.5419 12.4728C15.5631 12.5075 15.574 12.5474 15.5735 12.5881C15.573 12.6287 15.561 12.6683 15.539 12.7025C15.517 12.7366 15.4857 12.7638 15.4489 12.781V12.78Z",
    fill: "#252B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.3c703500b8be83d91a6165691159e728.svg";
export { ForwardRef as ReactComponent };